export default __webpack_public_path__ + "static/underline-best-mobile-2c50cd0dc584bf1891afedb217c6fceb.svg";